import { Routes } from '@angular/router';
import { RoleGuard } from '@guards/role.guard';

const masterDataModule = () => import('./master-data.module').then((m) => m.MasterDataModule);

export const masterDataRoutes: Routes = [
  {
    path: 'master-data',
    canActivateChild: [RoleGuard],
    loadChildren: masterDataModule,
    data: {
      enum: 'DISCOUNT_SETTING',
      label: 'Master Data',
      icon: 'ic_data_management.svg',
      activeClass: 'active',
      children: [
        {
          enum: 'SALES_DISCOUNT',
          label: 'List Data',
          path: 'master-data/list',
          children: [],
        },
        {
          enum: 'CBD_DISCOUNT',
          label: 'Tambah data',
          path: 'master-data/form',
          children: [],
        },
      ],
    },
  },
];
